




























































































































































































































































































import { Address, AddressBridge } from '@/views/address/bridge'
import {
  apiOrderExchangeGoodsExchangeGoodsPreOrder,
  ApiOrderExchangeGoodsExchangeGoodsPreOrderRequest,
  apiOrderExchangeGoodsExchangeGoodsTrade,
  apiTradeGeneralTradePreOrder,
  ApiTradeGeneralTradePreOrderRequest,
  ApiTradeGeneralTradePreOrderResponse,
  apiTradeGeneralTradeTradeOrder,
  apiTradeSecKillTradeSeckillConfirmResult,
} from '@/api'
import { computed, ref, watch } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi, useHistory, useQuery } from '@/hooks'
import { formatDate } from 'vtils/date'
import { globalModel } from '@/model'
import { isPossibleChineseMobilePhoneNumber, loopUntil, wait } from 'vtils'
import { mall } from '@/mall_jssdk'
import { prepareData, requiredDeep, submit, Track } from '@/utils'
import { redirectTo } from '@/router'
import { RequiredDeep } from 'vtils/types'
import { UserUtils } from '@/views/user/utils'
import { XPickCouponParams, XPickCouponResult } from '@/components'
import { yup } from 'vtils/validator'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '提交订单',
        }))

        watch(
          () => this.count.value,
          () => {
            this.realUserData.value = this.realUserData.value.slice(
              0,
              this.count.value,
            )
            for (
              let i = this.realUserData.value.length;
              i < this.count.value;
              i++
            ) {
              this.realUserData.value.push({
                name: '',
                phone: '',
                idCard: '',
              })
            }
          },
          {
            immediate: true,
          },
        )
      }

      query = useQuery<{
        /** 兑换商品 */
        sourceType?: 'exchange' | undefined
        /** 预下单请求数据 */
        preOrderRequestData: ApiTradeGeneralTradePreOrderRequest
        /** 预下单请求数据 */
        preOrderRequestData1: ApiOrderExchangeGoodsExchangeGoodsPreOrderRequest
        /** 预下单响应数据 */
        preOrderResponseData: ApiTradeGeneralTradePreOrderResponse
      }>({
        preOrderRequestData: {
          transformer: JSON.parse,
        },
        preOrderRequestData1: {
          transformer: JSON.parse,
        },
        preOrderResponseData: {
          transformer: JSON.parse,
        },
      })

      isSeckill = computed(
        () => +this.query.preOrderRequestData.preOrderType === 3,
      )

      isExchange = computed(() => this.query.sourceType === 'exchange')

      orderDate = computed(
        () => this.query.preOrderRequestData.skuInfo[0].stockDate,
      )

      count = useHistory(1)

      useDate = ref<Date>()

      showUseDatePicker = ref(false)

      formatDate = formatDate

      handleUseDatePickerConfirm = (date: Date) => {
        this.useDate.value = date
        this.showUseDatePicker.value = false
      }

      apiData = useApi(
        async () => {
          const { preOrderData, userData, address } = await prepareData({
            preOrderData: this.isSeckill.value
              ? Promise.resolve(
                  this.query
                    .preOrderResponseData as RequiredDeep<ApiTradeGeneralTradePreOrderResponse>,
                )
              : this.isExchange.value
              ? apiOrderExchangeGoodsExchangeGoodsPreOrder({
                  ...this.query.preOrderRequestData1,
                }).then(requiredDeep)
              : apiTradeGeneralTradePreOrder({
                  ...this.query.preOrderRequestData,
                  skuInfo: [
                    {
                      ...this.query.preOrderRequestData.skuInfo[0],
                      count: this.count.value,
                    },
                  ],
                }).then(requiredDeep),
            userData: UserUtils.getInfo(),
            address: AddressBridge.getDefaultAddress().then(
              res => res || {},
              () => ({}),
            ),
          })
          this.phoneNumber.value =
            this.phoneNumber.value || userData.phoneNum || ''
          this.address.value = address as any
          return preOrderData
        },
        {
          refreshOnChange: () => this.count.value,
          onError: () => this.count.rollback(),
        },
      )

      preOrderData = computed(() => this.apiData.data)

      orderData = computed(() => this.preOrderData.value.orderInfo[0])

      storeData = computed(() => this.preOrderData.value)

      goodsData = computed(() => this.orderData.value.commodityInfo[0])

      refundData = computed(() => this.orderData.value.writeOffRefund)

      needUserInfo = computed(() => this.orderData.value.needUserInfo)

      phoneNumber = ref('')

      name = ref('')

      address = ref<Address>({} as any)

      realUserData = ref<any[]>([])

      pickCouponParams = computed<XPickCouponParams>(() => ({
        goodsIdList: this.preOrderData.value.orderInfo.reduce<any[]>(
          (res, merchant) => {
            res.push(
              ...merchant.commodityInfo.map(goods =>
                JSON.stringify({
                  id: goods.resourceId,
                  name: goods.commodityName,
                  price: goods.unitPrice,
                  count: goods.count,
                  totalAmt: mall.calculator.sub(
                    goods.totalPrice,
                    goods.discountActivityAmount,
                  ),
                  superimposeDiscountType:
                    this.preOrderData.value.discountItems?.[0]?.type || null,
                  categoryId: goods.categoryId,
                }),
              ),
            )
            return res
          },
          [],
        ),
        amt: this.preOrderData.value.orderAmount,
        discountedAmt: mall.calculator.add(
          ...(this.preOrderData.value.discountItems || []).map(
            item => item.amount,
          ),
        ),
        businessType: this.preOrderData.value.businessType,
        unitOrgCode: this.preOrderData.value.unitOrgCode,
      }))

      pickCouponResult = ref<XPickCouponResult>({} as any)

      payAmount = computed(() =>
        mall.calculator.sub(
          // 订单金额
          this.preOrderData.value.orderAmount,

          // 减去优惠券金额
          this.pickCouponResult.value.discountedAmt || 0,

          // 减去折扣优惠金额
          _ =>
            _.add(
              ...(this.preOrderData.value.discountItems || []).map(
                item => item.amount,
              ),
            ),
        ),
      )

      // 点击选择地址
      handleChooseAddressClick = async () => {
        const address = await AddressBridge.chooseAddress()
        if (address && address.id) {
          this.address.value = address
        }
      }

      handlePayClick = () => {
        submit(async $ => {
          if (
            !this.preOrderData.value.needAddress &&
            (!this.phoneNumber.value ||
              !isPossibleChineseMobilePhoneNumber(this.phoneNumber.value))
          ) {
            return $.fail('请输入正确的手机号')
          }

          if (this.preOrderData.value.needUseDate && !this.useDate.value) {
            return $.fail('请选择使用日期')
          }

          if (this.preOrderData.value.needAddress && !this.address.value.id) {
            return $.fail('请选择收货地址')
          }

          if (this.needUserInfo.value) {
            const rule = yup.object({
              name: yup.string().label('姓名').required(),
              phone: yup
                .string()
                .label('联系电话')
                .required()
                .chineseMobilePhoneNumber(),
              idCard: yup
                .string()
                .label('身份证号')
                .required()
                .chineseIDCardNumber(),
            })
            for (const item of this.realUserData.value) {
              const { error } = rule.validatePlusSync(item)
              if (error) {
                return $.fail(error.message)
              }
            }
          }

          $.start()
          let payData = await (this.isExchange.value
            ? apiOrderExchangeGoodsExchangeGoodsTrade
            : apiTradeGeneralTradeTradeOrder)({
            preOrderId: this.preOrderData.value.preOrderId,
            consigneeName: this.address.value.receiver,
            consigneeTel: this.address.value.phoneNo,
            consigneeAddress: {
              province: this.address.value.province,
              city: this.address.value.city,
              area: this.address.value.county,
              areaCode: this.address.value.districtCode,
              detail: this.address.value.detail,
              name: this.preOrderData.value.needAddress
                ? this.address.value.receiver
                : this.name.value,
              phoneNo: this.preOrderData.value.needAddress
                ? this.address.value.phoneNo
                : this.phoneNumber.value,
            },
            tradeOrderInfo: [
              {
                orderId: this.orderData.value.orderId,
                count: this.count.value,
                userInfoList: this.needUserInfo.value
                  ? this.realUserData.value
                  : [],
                // @ts-ignore
                stockDate: this.useDate.value
                  ? formatDate(this.useDate.value, 'yyyy-mm-dd')
                  : undefined,
              },
            ],
            couponId: this.pickCouponResult.value.couponId,
            discountAmount: this.pickCouponResult.value.discountedAmt || 0,
            payType: globalModel.state.payType as any,
            openId: globalModel.state.openid,
          })
          Track.pushEvent({
            type: 'click',
            name: '提交订单',
            id: 'TiJiaoDinDan',
            extra: {
              order_id: payData.orderId,
              order_price: this.payAmount.value,
              commodity_id: this.preOrderData.value.orderInfo
                .reduce<string[]>((res, merchant) => {
                  res.push(
                    ...merchant.commodityInfo.map(goods => goods.commodityId),
                  )
                  return res
                }, [])
                .join(','),
              commodity_name: this.preOrderData.value.orderInfo
                .reduce<string[]>((res, merchant) => {
                  res.push(
                    ...merchant.commodityInfo.map(
                      goods => goods.commodityName,
                    ),
                  )
                  return res
                }, [])
                .join(','),
              original_price: this.preOrderData.value.orderAmount,
              present_price: this.payAmount.value,
              discount_price:
                this.preOrderData.value.orderAmount - this.payAmount.value,
              submit_type: '立即支付',
            },
          })
          if (this.isSeckill.value) {
            const res = await loopUntil(
              () => apiTradeSecKillTradeSeckillConfirmResult(),
              res => res.confirmState !== 0,
              {
                retryDelay: 500,
              },
            )
            if (res.confirmState === 2) return $.fail(res.msg!)
            payData = res.result as any
          }

          if (this.isExchange.value) {
            $.success('兑换成功')
            redirectTo('OrderExchangeResult', {
              id: payData.orderId,
              sourceType: 4,
            })
            return
          }

          try {
            await dcb.requestPayment({
              provider: 'native',
              showNativeResultPage: false,
              params: payData,
            })
            await wait(1000)
            redirectTo('BookOrderIndex')
          } catch {
            redirectTo('BookOrderIndex')
          }
        })
      }
    },
)
